var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudentComment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.03 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 35.66c.2-.92.34-1.86.61-2.77.43-1.49.91-3 1.43-4.45a7.36 7.36 0 013-3.73 18.85 18.85 0 019.14-3.11 12.18 12.18 0 013.88.55 20.08 20.08 0 015.25 2.17 8.72 8.72 0 013.86 4.57 35.82 35.82 0 011.73 6.5 2.14 2.14 0 00.09.27V36h-29zM15.45 0c.53.11 1.06.2 1.59.34a9.8 9.8 0 01-.48 19 9.58 9.58 0 01-11.3-7 9.78 9.78 0 016.91-12c.47-.12.95-.2 1.43-.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentComment);
export default __webpack_public_path__ + "static/media/student-comment.1375edc3.svg";
export { ForwardRef as ReactComponent };